<template>
  <div class="chatroom-box-wrap">
    <div class="upgrade-wrap" v-if="isUpgrade && loaded">
      <img src="//static.fly2a.com/static/image/f-live/upgrading.png" />
      <span>聊天室正在升级</span>
    </div>
    <div class="chatroom-wrap" v-else>
      <div class="title">
        <span class="chatname">
          <img src="//static.fly2a.com/gqj_tv/image/chats.png" width="16px" />&ensp;
          <span>{{ (curTv.name || curTv.username) ? (curTv.name || curTv.username) : "" }}</span>
          <span>{{ (curTv.name || curTv.username) ? "的" : "" }}聊天室</span>
        </span>
        <span class="count">
          <img src="//static.fly2a.com/006zhibo/image/eye.png" width="16px" />
          <span class="text">{{ curTv.room_user_num | viewerNum }}</span>
        </span>
      </div>
      <div class="msg-list">
        <div class="follow" v-if="(curTv.name || curTv.username) != '公共' && curTv.type == 2"
          @mousemove="qrcodeShow($event)" @mouseleave="qrcodeHide()">
          <div class="anchor">
            <img :src="curTv.face" alt />
            <span>
              <div class="name">{{ curTv.name || curTv.username }}</div>

              <!-- <span class="wx" v-if="curTv.wx_num">
                <span>账号:{{ curTv.wx_num }}</span>
              </span> -->
              <div :class="!curTv.is_follow ? 'follow_btn' : 'follow_btn active'" @click="followFn()"
                v-if="curTv.member_id != getCookie('member_id')">
                <template v-if="curTv.is_follow">
                  已关注
                </template>
                <template v-else>
                  <span class="follow_add">+</span><span>关注</span>
                </template>
              </div>
            </span>
          </div>
          <div class="qrcode" v-if="curTv.qrcode">
            <img :src="curTv.qrcode" />
          </div>
          <div class="follow_msg" v-if="followMsgTxt">
            {{ followMsgTxt }}
          </div>
          <div class="max-qrcode">
            <img :src="curTv.qrcode" />
          </div>
          <!-- <div class="wx_qrcode" v-show="curTv.wx_code && qrcode_show">
            <div>
              <img :src="curTv.wx_code" alt />
            </div>
            <div class="wx_qrcode_title">
              扫一扫 <br /> 加主播账号
            </div>
          </div> -->
        </div>

        <div class="chatroom-notice">
          <span style="display: flex; flex-direction: row">
            <img src="@/assets/images/icon-notice.png" alt="">
            <marquee class="horn">
              <span v-html="curTv.member_id == 0 ? curTv.room_notice || commonChatroomNotice  : `欢迎来到主播【${curTv.name}】的直播间,` + curTv.room_notice || commonChatroomNotice"></span>
            </marquee>
          </span>
        </div>

        <div id="chatroom" class="text_msg per-content" ref="scrollDiv" @scroll="onScroll"
          :style="curTv.name != '公共' && curTv.type == 2 ? 'top: 89px;' : 'top: 38px;'">
          <ul class="chatroom-wrapper">
              <li class="msg-item history-loading" v-show="isGetHistoryMsgs">
                  <div class="loading-spinner">
                      <span class="spinner"></span>
                      <span>Loading...</span>
                  </div>
              </li>
              <template >
                <msgItem v-for="(msg, idx) in filterMsgs" :key="`${msg.mid}-${idx}-msg`" @forbidden="forbidden" @delmsg="delmsgConfirm" :isDel="isDel"
                  :isBan="isBan" :msg="msg" />
              </template>
          </ul>
        </div>

      </div>
      <div class="msg-post">
        <textarea class="msg-content" placeholder="请输入..." id="textarea" @keydown.enter="onSubmit"></textarea>
        <div class="say-btn">
          <div class="shield" v-if="shield.show">
            <div @click="shieldFn()">
              <span>
                <i class="iconfont2" v-if="!shield.shieldALL"></i>
              </span>
              <img src="//static.fly2a.com/006zhibo/image/checked.png" alt v-if="shield.shieldALL" width="16px" />
              <span>屏蔽所有入场消息</span>
            </div>
          </div>
          <img
            :src="shield.shieldALL || shield.shieldYK ? '//static.fly2a.com/gqj_tv/image/shield2.png' : '//static.fly2a.com/gqj_tv/image/shield1.png'"
            @click="shield.show = !shield.show" width="22px" />
          <i class="iconfont btn btn-default face-btn face pull-left">&#xe656;</i>
          <input type="submit" class="btn btn-default submit-btn" value="发表" id="subBtn" @click="onSubmit()" />
        </div>
      </div>
      <div class="more-message-bar" v-show="showMoreBar" @click="scrollToLocation">
        <!-- <img class="icon" src="../assets/img/icon-down.png" /> -->
        有新的消息
      </div>
    </div>


  </div>
</template>

<script>
import msgItem from './msgItem.vue'
import axios from 'axios'

const inTest = ['localhost', 'dev-web.gqjcs.com'].indexOf(location.hostname) > -1

const wsPrefix = (/^https/.test(location.href) ? 'wss://' : 'wss://') + (inTest ? 'dev-ws-im.gqjcs.com/' : 'ws.gqjim.com/')

const wsURL = `${wsPrefix}`

export default {
  name: "Chatroom-V2",
  components: {
    msgItem
  },
  props: {
    match: {
      type: Object,
      default: () => ({})
    },
    curTv: {
      type: [Object, null]
    }
  },
  data() {
    return {
      followMsgTxt: '',
      qrcode_show: 0,
      isUpgrade: false,
      sending: false,
      isBan: false,
      isDel: false,
      shield: {
        shieldYK: false,
        shieldALL: false,
        show: false,
      },
      follow: [],
      histories: [],
      msgList: [],
      banUids: [],
      ws: {
        url: wsURL,
        instance: null,
        timer: null,
        tryCount: 9999,
        heartTimer: null,
        room_uid: "",
        subscribed: []
      },
      loaded: false,
      needWelcome: true,

      curScroH: 0,
      curHeight: 0,
      isGetHistoryMsgs: false,
      nomoreHistory: false,
      
      hasMoreMessages: false,
      showMoreBar: false
    }
  },
  filters: {
    viewerNum(viewer) {
      if (viewer > 10000) {
        return (viewer / 10000).toFixed(2) + "万"
      } else {
        return viewer
      }
    }
  },
  watch: {
    'curTv.room_id': function (n, o) {
      if (n !== o && n) {
        this.isUpgrade = false
        this.histories = []
        this.msgList = []
        this.banUids = []
        this.isGetHistoryMsgs = false
        this.nomoreHistory = false
        if (this.ws && this.ws.instance) {
          this.ws.instance.close()
          this.ws.instance = null
          this.ws.tryCount = 0
          this.ws.handleClose = true
        }
        this.getHistory({room_id: this.curTv.room_id})
        this.createdChatroom(`${this.curTv.room_id}`)
        this.$nextTick(() => {
          this.initEmoji()
        })
      }
      if (!n) {
        this.isUpgrade = true
      }
    },
  },
  computed: {
    formatNotice() {
      const v = this.match.room_notice || this.commonChatroomNotice
      return v.replace(/<([^>]*)>/g, function (vv) {
        vv = vv.replace(/</, '').replace(/>/, '')
        return `<a href=${vv} target=_blank>${vv}</a>`
      })
    },
    filterMsgs() {
      let msgs = this.msgList
      if (this.shield.shieldALL) {
        msgs = msgs.filter(msg => msg.content_type != 'system')
      }
      if (this.banUids.length > 0) {
        msgs = msgs.filter(msg => {
          return !this.banUids.includes(msg.uid)
        })
      }
      return msgs
    }
  },
  methods: {
    getFollowAnchor() {
      var token = this.getCookie("token");
      axios
        .get(COMMOND.NEW_BASE_URL + "get_anchor_ids", {
          headers: {
            Authorization: token,
          },
        })
        .then((res) => {
          var data = res.data.data;
          this.follow = data;
        });
    },
    followFn() {
      var token = this.getCookie("token");
      if (!token) {
        $(".loading").show();
        $(".loading_content1").show();
        $(".zhuce").show();
        $(".loading_content2").hide();
        //            $(".authimg").attr("src", COMMOND.NEW_BASE_URL  + "get_img_code?"+Math.random()*10000);
        return;
      }
      var token = this.getCookie("token");
      var type = 0;
      axios
        .post(
          COMMOND.NEW_BASE_URL + "follow_anchor", {
          member_id: this.curTv.member_id,
          is_follow: !this.curTv.is_follow,
        }, {
          headers: {
            Authorization: token,
          },
        }
        )
        .then((res) => {
          if (res.data.code == 200) {
            if (!this.curTv.is_follow) {
              this.curTv.is_follow = 1;
              this.follow.push(this.curTv.member_id);
              this.followMsg("关注成功");
            } else {
              this.curTv.is_follow = 0;
              this.follow.splice(
                this.follow.indexOf(this.curTv.member_id),
                1
              );
              this.followMsg("取消关注成功");
            }
          } else {
            this.followMsg(res.data.msg);
          }
        });
    },
    followMsg(msg) {
      var that = this;
      this.followMsgTxt = msg;
      setTimeout(function () {
        that.followMsgTxt = "";
      }, 1500);
    },
    qrcodeShow(e) {
      var positionX = e.pageX - $(".follow").offset().left; //获取当前鼠标相对img的X坐标
      if (positionX > 0) {
        this.qrcode_show = 1;
      } else {
        this.qrcode_show = 0;
      }
    },
    qrcodeHide() {
      this.qrcode_show = 0;
    },
    shieldFn() {
      if (this.shield.shieldALL) {
        window.localStorage.setItem("shield", '0');
      } else {
        window.localStorage.setItem("shield", '1');
      }
      this.shield.shieldALL = !this.shield.shieldALL;
      this.shield.show = false;
      this.$nextTick(function () {
        this.scrollToLocation();
      });
    },
    scrollToLocation() {
      // $("#chatroom").parseEmotion()
      let scrollElem = this.$refs.scrollDiv;
      if (scrollElem) {
        scrollElem.scrollTo({ top: scrollElem.scrollHeight, behavior: 'smooth' });
      }
    },
    async createdChatroom(uid) {
      var token = this.getCookie("token");
      const member_id = this.getCookie("member_id")
      if (this.ws.instance) {
        this.subscribe(uid)
      } else {
        const tokenRes = await axios.get(COMMOND.NEW_BASE_URL + 'ws_token?os=web', {
          headers: {
            Authorization: token,
          },
        })
        if (!tokenRes || tokenRes.status !== 200 || tokenRes.data.code !== 200) {
          return
        }
        const wsToken = tokenRes.data.data.t
        this.ws.instance = new WebSocket(`${this.ws.url}?os=web&t=${wsToken}`)
        this.ws.handleClose = false
        this.ws.instance.onopen = (event) => {
          this.ws.tryCount = 9999
          // bus.$emit('ws.open', event)
          this.heartbeat()
        };
        this.ws.instance.onerror = (event) => {
          console.warn("ws.error", event);
        };
        this.ws.instance.onclose = (event) => {
          console.warn(event)
          this.ws.instance = null;
          this.ws.timer && clearTimeout(this.ws.timer);
          if (--this.ws.tryCount > 0) {
            this.ws.timer = setTimeout(() => {
              console.info('ws.reconnect')
              this.createdChatroom(uid);
            }, 5000);
          } else {
            if (!this.ws.handleClose) {
              location.reload()
            }
          }
        };

        this.ws.instance.onmessage = (event) => {
          console.log(event);
          try {
            const data = this.isString(event.data) ? JSON.parse(event.data) : event.data;
            data.data = this.isString(data.data) ? JSON.parse(data.data) : data.data
            // bus.$emit('ws.message', data)
            // typeof msgCallback == 'function' && msgCallback(data)
            this.onMessage(data)
            if (data.event == 'woker:connection_established') {
              this.subscribe(uid)
            } else if (data.event == 'woker_internal:subscription_succeeded') {
              if (/^room-/.test(data.channel)) {
                const room_uid = data.channel.replace(/^room-/, '')
                this.ws.room_uid = room_uid
              }
            }
          } catch (e) {
            console.warn('ws.event.parse.error', e)
          }
        };
      }
    },
    heartbeat() {
      this.ws.heartTimer && clearTimeout(this.ws.heartTimer)
      this.ws.heartTimer = setTimeout(() => {
        this.send({
          event: "woker:ping"
        });
        this.heartbeat()
      }, 5000)
    },
    subscribe(uid) {
      uid = uid || this.ws.room_uid
      if (!uid) {
        return
      }
      this.send({
        event: "woker:subscribe",
        data: {
          channel: `room-${uid}`
        }
      })
      return false
    },
    send(data) {
      if (this.ws.instance && this.ws.instance.readyState == 1) {
        console.info('ws.send', data)
        this.ws.instance.send(JSON.stringify(data))
        return true
      }
      return false
    },
    isString(data) {
      return ({}).toString.call(data) === '[object String]'
    },
    onMessage(data) {
      // 欢迎信息
      if (data && data.event == 'room' && (data.channel == `room-${this.curTv.room_id}` || data.channel == `room-${this.curTv.roomid}`)) {
        console.log();
        if (this.shield.shieldALL && data.data.content_type === 'system') {
          return
        }
        // 游客欢迎限制 2s 一次
        if (!data.data.uid) {
          // 2s 一次欢迎
          if (this.needWelcome) {
            this.needWelcome = false
            this.msgList.push(data.data)
            const welcomeTime = setTimeout(() => {
              this.needWelcome = true
              clearTimeout(welcomeTime)
            }, 2000)
          }
        } else {
          this.msgList.push(data.data)
        }
        this.$nextTick(() => {
          this.scrollToLocation();
        })
      }
      // 发消息
      if (data && data.event == 'roomMsg' && data.channel == `room-${this.curTv.room_id}` && this.msgList.findIndex(msg => msg.mid == data.data.mid) == -1) {
        if (this.shield.shieldALL && data.data.content_type === 'system') {
          return
        }
        this.msgList.push(data.data)
        if (this.hasMoreMessages) {
          this.showMoreBar = true
        } else {
          this.$nextTick(() => {
            this.scrollToLocation();
          });
        }
      }
      if (data && data.event == 'delRoomMsg' && data.channel == `room-${this.curTv.room_id}`) {
        data.data.mid.forEach((item, idx) => {
          data.data.mid[idx] = parseInt(item)
        })
        this.msgList = this.msgList.filter(msg => !data.data.mid.includes(msg.mid))
      }

      // 用户被禁言后，过滤被禁言用户消息
      if (data && data.event === 'banUser' && (data.data.room_id == this.curTv.room_id || data.data.type == '2')) {
        this.banUids.push(data.data.ban_uid)
      }
      // 解除禁言
      if (data && data.event === 'unBanUser' && (data.data.room_id == this.curTv.room_id || data.data.type == '2')) {
        const idx = this.banUids.findIndex(data.data.uid)
        if (idx > -1) {
          this.banUids.splice(idx, 1)
        }
      }
    },
    async getHistory(params) {
      if(this.isGetHistoryMsgs || this.nomoreHistory) return
      this.isGetHistoryMsgs = true
      const token = this.getCookie("token");
      const { data: res } = await axios.get(`${COMMOND.NEW_BASE_URL}room/message/history`,
      {
          params,
          headers: {
            Authorization: token,
          },
      })
      
      if(res && res.code == 200 && res.data){
        const response = res.data;
        this.msgList = [...response.data, ...this.msgList]
        this.isBan = response.is_ban;
        this.isDel = response.is_del;
        this.nomoreHistory = response.data.length < 50
        this.$nextTick(() => {
          if(!params.mid){ //首次加载跳转到最新
            this.curHeight = $('#chatroom .chatroom-wrapper').height()
            this.scrollToLocation();
          }else{
            this.scrollToOldHeight({isScroll: params.hasOwnProperty('mid')})
          }
        });
      }
      this.isGetHistoryMsgs = false
    },
    onScroll(e) {
      const { offsetHeight, scrollHeight, scrollTop } = e.target
      if (scrollHeight > offsetHeight && offsetHeight + scrollTop + 120 < scrollHeight) {
        this.hasMoreMessages = true
      } else {
        this.hasMoreMessages = false
        this.showMoreBar = false
      }
            
      let JscrollTop = $('#chatroom').scrollTop()
      
      /**
       * 滚动方向 触发距离 触发距离内防止多次触发 更多数据或未在加载中
       */
      if(JscrollTop < this.curScroH
      && JscrollTop < 50
      && this.curScroH >= 50
      && this.msgList.length
      && !this.nomoreHistory
      && !this.isGetHistoryMsgs){
          const params = {
              room_id: this.curTv.room_id,
              mid: this.msgList[0].mid,
              compare: 'desc'
          }
          this.getHistory(params)
      }
      this.curScroH = JscrollTop;
    },
    scrollToOldHeight(isScroll){
        this.$nextTick(e=>{
            if(isScroll){
                let sct = $('#chatroom .chatroom-wrapper').height() - this.curHeight + this.curScroH - $('.history-loading').height()
                this.curHeight = $('#chatroom .chatroom-wrapper').height()
                setTimeout(()=>{
                    $('#chatroom').scrollTop(sct)
                }, 0)
            }
        })
    },
    onSubmit() {
      var token = this.getCookie("token");
      if (!token) {
        $(".loading").show();
        $(".loading_content1").show();
        $(".zhuce").show();
        $(".loading_content2").hide();
        return false
      }
      if (this.sending) {
        return this.$message.error('客官,说话太快啦(つД`)');
      }
      var input = document.getElementById("textarea");
      var chatroomTxt = ''
      console.warn(input.value)
      if (input.value.trim()) {
        chatroomTxt = input.value.replace(/"/g, '\\"').replace(/\n/g, '').replace(/\r/g, '');
        // 取消屏蔽敏感词
        // if (getCookie("type") != 9 && getCookie("type") != 5 && getCookie("type") != 2 && getCookie("type") != 6) {
        //   chatroomTxt = chatroomTxt.replace(/[7-9]/g, "*").replace(/[a-m,o-z,A-Z]/g, "*").replace(
        //     /[⒎,⒏,⒐,⁷,⁸,⁹,₇,₈,₉,➐,➑,➒,⑦,⑧,⑨,⓻,⓼,⓽,⑺,⑻,⑼,７,８,９,七,八,九,㊆,㊇,㊈,㈦,㈧,㈨,𝟕,𝟖,𝟗]/g, "*").replace(/'郝'/g, "*");
        // }
      }
      if (chatroomTxt) {

        this.sending = true;
        let timer = setTimeout(() => {
          this.sending = false;
        }, 60000)
        const content = chatroomTxt.replace(/\n/, '');
        const member_id = this.getCookie("member_id")
        axios
          .post(
            COMMOND.NEW_BASE_URL + "room/message/send",
            {
              yx_room_id: Number(this.curTv.roomid),
              room_id: Number(this.curTv.room_id) || Number(this.curTv.roomid),
              content_type: 'txt',
              content
            },
            {
              headers: {
                Authorization: token,
              },
            }
          )
          .then(res => {
            if (res.data.code == 200) {
              chatroomTxt = '';
              input.value = "";
              input.focus();
              this.onMessage({
                event: 'roomMsg',
                data:res.data.data,
                channel: `room-${this.curTv.room_id}`
              })
            } else {
              this.$message.error(res.data.msg);
            }
            clearTimeout(timer)
            setTimeout(() => {
              this.sending = false;
            }, 3000);
          })
      } else {
        // this.$message.error(res.data.msg);
      }
    },
    forbiddenConfirm(msg) {
      var token = this.getCookie("token");
      const member_id = this.getCookie("member_id")
      const ext = JSON.parse(msg.ext)
      axios
        .post(
          COMMOND.NEW_BASE_URL + "room/ban_user",
          {
            yx_room_id: Number(this.curTv.roomid),
            room_id: Number(this.curTv.room_id),
            ban_uid: msg.uid,
            acc_uid: ext.uid,
            acc_platform: ext.platform
          },
          {
            headers: {
              Authorization: token,
            },
          }
        )
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('禁言成功！');
          } else {
            this.$message.error(res.data.msg);
          }
        })
    },
    delmsgConfirm(msg) {
      var token = this.getCookie("token");
      const member_id = this.getCookie("member_id")
      axios
        .post(
          COMMOND.NEW_BASE_URL + "room/message/del",
          {
            room_id: Number(this.curTv.room_id),
            mid: msg.mid,
            from_uid: msg.uid
          },
          {
            headers: {
              Authorization: token,
            },
          }
        )
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('删除成功！');
          } else {
            this.$message.error(res.data.msg);
          }
        })
    },
    initEmoji() {
      $(".face-btn").click(function (event) {
        $(this).sinaEmotion($("textarea"));
        event.stopPropagation();
      });
    },
  },
  mounted() {
    const shield = Number(window.localStorage.getItem("shield"))
    this.shield.shieldALL = shield
    if (this.curTv.room_id) {
      this.isUpgrade = false
      this.getHistory({room_id: this.curTv.room_id})
      this.createdChatroom(`${this.curTv.room_id}`)
      this.initEmoji()
    } else if (this.curTv.roomid) {
      this.isUpgrade = false
      this.getHistory({room_id: this.curTv.room_id})
      this.createdChatroom(`${this.curTv.roomid}`)
      this.initEmoji()
    } else {
      this.isUpgrade = true
    }
    this.loaded = true
  }
}
</script>

<style lang="less" scoped>
.upgrade-wrap {
  display: flex;
  display: none;
  flex-direction: column;
  align-items: center;
  width: 272px;
  text-align: center;
  height: 100%;
  background: #fff;

  img {
    width: 120px;
    margin-top: 130px;
    margin-bottom: 20px
  }

  span {
    font-size: 16px;
    font-weight: 700;
    font-family: cursive;
    padding-left: 5px;
    color: #656363
  }
}

.chatroom-box-wrap {
  height: 100%;
}

.chatroom-wrap {
  border: 1px solid #ededed;
  width: 272px;
  // min-height: 600px;
  height: 100%;
  display: flex;
  flex-direction: column
}

.chatroom-wrap ::-webkit-scrollbar {
  width: 6px;
  height: 16px;
  background-color: transparent
}

.chatroom-wrap ::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: transparent
}

.chatroom-wrap ::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background-color: #e4e4e4
}

.chatroom-wrap .title {
  flex-basis: 30px;
  line-height: 30px;
  padding: 0 15px;
  color: #c1c0c0;
  font-size: 14px;
  background-color: #fff;
  border-width: 0 0 1px 0;
  border-style: solid;
  border-color: #dfdedf
}

.chatroom-wrap .title .chatname {
  color: #f43e50;
  font-size: 13px;
  display: inline-block;
  vertical-align: middle;
  margin-top: -1px
}

.chatroom-wrap .title .chatname span {
  display: inline-block;
  line-height: normal;
  vertical-align: middle
}

.chatroom-wrap .title .chatname span:nth-child(2) {
  max-width: 81px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

.chatroom-wrap .title .chatname img {
  vertical-align: middle
}

.chatroom-wrap .title .count {
  float: right
}

.chatroom-wrap .title .count i {
  vertical-align: middle
}

.chatroom-wrap .msg-list {
  flex: 1;
  position: relative;
}



.chatroom-wrap .msg-list .follow {
  background: #fff;
  border-bottom: 1px solid #ededed;
  overflow: hidden;
  padding: 5px 15px 5px 11px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}

.chatroom-wrap .msg-list .follow .anchor {
  display: flex;
  align-items: center;
}

.chatroom-wrap .msg-list .follow .anchor>img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 8px
}

.chatroom-wrap .msg-list .follow .anchor>span {
  display: inline-block;
  vertical-align: middle;
  width: 134px;
  padding-top: 2px;
}

.chatroom-wrap .msg-list .follow .anchor .name {
  display: inline-block;
  width: 134px;
  font-size: 15px;
  line-height: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden
}

.chatroom-wrap .msg-list .follow .anchor .wx {
  display: inline-block;
  font-size: 12px;
  color: #898888;
  margin-top: 3px;
  margin-left: -2px;
  white-space: nowrap
}

.chatroom-wrap .msg-list .follow .anchor .wx img {
  width: 15px;
  vertical-align: middle;
  margin-right: 2px
}

.chatroom-wrap .msg-list .follow .follow_btn {
  width: 59px;
  height: 24px;
  border: 1px solid #e84d5b;
  color: #e84d5b;
  border-radius: 12px;
  text-align: center;
  line-height: 20px;
  margin-top: 6px;
  cursor: pointer
}

.chatroom-wrap .msg-list .follow .follow_btn.active {
  border: 1px solid #999;
  color: #999;
  line-height: 23.5px
}

.chatroom-wrap .msg-list .follow .follow_btn .follow_add {
  font-size: 16px;
  font-weight: 700;
  padding-right: 2px
}

.chatroom-wrap .msg-list .follow .follow_msg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(18, 18, 18, .4);
  padding: 10px 20px;
  color: #fff;
  border-radius: 18px;
  font-size: 14px;
  z-index: 10
}

.chatroom-wrap .msg-list .follow .wx_qrcode {
  position: absolute;
  top: 50px;
  left: 5px;
  background: #fff;
  z-index: 1;
  padding: 15px;
  box-shadow: 0 0 19px 1px rgba(51, 51, 51, .26);
  text-align: center;
  color: #333
}

.chatroom-wrap .msg-list .follow .wx_qrcode img {
  width: 84px
}

.chatroom-wrap .msg-list .follow .wx_qrcode .wx_qrcode_title {
  line-height: 15px;
  margin-top: 5px
}

.chatroom-wrap .msg-list .follow .wx_qrcode:before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 11px;
  height: 11px;
  box-shadow: 0 0 4px 0 rgba(68, 68, 68, .3);
  transform: rotate(-45deg) translate(-50%, -50%) skew(6deg, 6deg);
  background: #fff;
  top: -6px;
  left: 50%
}

.qrcode:hover~.max-qrcode {
  display: block;
}

.qrcode {
  cursor: pointer;
  position: relative;

  img {
    width: 42px;
    height: 42px;
  }

}

.max-qrcode {
  position: absolute;
  display: none;
  z-index: 999;
  right: 15px;
  top: 59px;
  width: 200px;
  height: 204px;
  background: #FFFFFF;
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.27);
  border-radius: 10px;
  background-color: #fff;
  padding: 10px;

  img {
    width: 100%;
    height: 100%;
    z-index: 999;
  }
}

.msg-list .follow .wx_qrcode:after {
  content: "";
  display: inline-block;
  position: absolute;
  top: -16px;
  left: 24%;
  width: 30px;
  height: 9px;
  background: #fff;
  transform: translate(7px, 16px)
}

.chatroom-wrap .msg-list .per-content {
  position: absolute;
  overflow-y: scroll;
  left: 0;
  top: 79px;
  right: 0;
  bottom: 0;
  padding: 9px 0 9px 12px
}

.chatroom-wrap .msg-list .per-content li .identify {
  line-height: 18px;
  float: left;
  font-size: 12px;
  background: #ffd874;
  color: #fff;
  border-radius: 5px;
  width: 46px;
  text-align: center;
  margin-right: 5px
}

.chatroom-wrap .msg-list .per-content li:not(:last-child) {
  margin-bottom: 5px
}

.chatroom-wrap .msg-list .per-content li {
  font-size: 14px;
  line-height: 18px;
  color: #333
}

.chatroom-wrap .msg-list .per-content li.enter {
  color: #ffa200
}

.per-content li.history-loading{
  margin-bottom: 0;
  padding: 2px 0;
  color: #333;
  .loading-spinner{
      display: flex;
      justify-content: center;
      align-items: center;
  }
  .loading-spinner .spinner{
      display: inline-block;
      width: 20px;
      height: 20px;
      border: 2px solid rgba(0, 0, 0, 0.3);
      border-top-color: transparent;
      border-radius: 100%;
      animation: circle infinite 0.75s linear;
  }
  .loading-spinner span{
      font-size: 14px;
      margin-left: 5px;
      color: rgba(0, 0, 0, 0.3);
  }
  @keyframes circle {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}

.chatroom-wrap .msg-post {
  flex-basis: 65px;
  border-width: 1px 0 0 0;
  border-style: solid;
  border-color: #cbc8c7;
  position: relative
}

.chatroom-wrap .msg-post textarea {
  width: 100%;
  height: 60px;
  outline: none;
  resize: none;
  border: 0;
  padding: 10px 12px
}

.chatroom-wrap .msg-post .say-btn {
  padding: 0 10px;
  height: 28px
}

.chatroom-wrap .msg-post .say-btn i,
.chatroom-wrap .msg-post .say-btn img {
  float: left;
  cursor: pointer
}

.chatroom-wrap .msg-post .say-btn>img {
  margin-right: 10px
}

.chatroom-wrap .msg-post .say-btn .shield {
  position: absolute;
  bottom: -40px;
  left: 0;
  color: #fff;
  background: rgba(0, 0, 0, .7);
  border-radius: 5px;
  white-space: nowrap;
  z-index: 200
}

.chatroom-wrap .msg-post .say-btn .shield>div {
  font-size: 14px;
  padding: 3px 10px;
  line-height: 30px;
  cursor: pointer
}

.chatroom-wrap .msg-post .say-btn .shield>div.yk {
  border-bottom: 1px solid hsla(0, 0%, 100%, .4)
}

.chatroom-wrap .msg-post .say-btn .shield>div i {
  width: 16px;
  height: 16px;
  border: 1px solid #e5e5e5;
  border-radius: 50%
}

.chatroom-wrap .msg-post .say-btn .shield>div img {
  vertical-align: middle;
  margin-top: 7px
}

.chatroom-wrap .msg-post .say-btn>i.active {
  color: #e84d5d
}

.chatroom-wrap .msg-post .say-btn .shield>div i,
.chatroom-wrap .msg-post .say-btn .shield>div span {
  display: inline-block;
  vertical-align: middle
}

.chatroom-wrap .msg-post .say-btn .shield:before {
  content: "";
  width: 0;
  height: 0;
  position: absolute;
  top: -16px;
  left: 8%;
  border: 8px solid rgba(0, 0, 0, .7);
  border-top-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent
}

.chatroom-wrap .msg-post .say-btn .face-btn {
  font-size: 22px;
  margin-top: 6px;
  color: #c1c1c6;
  cursor: pointer
}

.chatroom-wrap .msg-post .say-btn .face-btn:hover {
  color: #ffa03b
}

.chatroom-wrap .msg-post .say-btn .submit-btn {
  text-align: center;
  text-decoration: none;
  width: 63px;
  height: 25px;
  line-height: 25px;
  background-color: #ffa03b;
  border-radius: 25px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  float: right
}

.chatroom-wrap .loginname {
  color: #00baff
}

.chatroom-wrap .loginname,
.chatroom-wrap .loginrealname {
  float: left;
  cursor: pointer;
  white-space: nowrap
}

.chatroom-wrap .loginrealname {
  color: #e84d5d
}

.chatroom-wrap .loginname,
.chatroom-wrap .loginrealname {
  display: inline-block;
  max-width: 100px;
  text-overflow: ellipsis;
  overflow: hidden
}

.chatroom-wrap .text {
  word-break: break-word
}

.chatroom-wrap .text img.sina-emotion {
  display: inline-block;
  vertical-align: middle;
  width: 22px;
  height: 22px;
  margin: -5px 5px 0
}

.more-message-bar {
  position: absolute;
  bottom: 140px;
  right: 0;
  z-index: 9;
  padding: 6px 12px;
  border-radius: 12px 0 0 12px;
  background: #f5f6f7;
  color: #e60101
}
</style>
<style>
.chatroom-notice{
  background: rgba(223, 70, 85, 0.1);
  height: 32px;
  display: flex;
  align-items: center;
  color: #E44013;
  img{
    width: 16px;
    height: 16px;
    margin:0 8px;
  }
  .horn span a{
    color: #DF4655;
    text-decoration: underline;
  }

}
</style>